import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Page1 from './pages/Page1';
import Page2 from './pages/Page2';
import Page3 from './pages/Page3';
import Page4 from './pages/Page4';
import Page5 from './pages/Page5';
import './App.css';
import { Navigate } from 'react-router-dom';
import Radio from './pages/Radio';
import { useEffect } from 'react';
import Constelacao from './pages/constelacao';
import Console from './pages/Consoole';

// Componente de debug para testar rotas
const DebugRoute = ({ pageNumber }) => (
  <div style={{ 
    padding: '2rem', 
    backgroundColor: '#333', 
    color: 'white', 
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  }}>
    <h1>Debug - Página {pageNumber}</h1>
    <p>Rota /{pageNumber} está funcionando!</p>
  </div>
);

export function initPage(){
    const baseWidth = 1920;
    const baseHeight = 1080;

    // Reduz a área disponível para 80% (deixando 10% de borda em cada lado)
    const availableWidth = window.innerWidth * 0.8;
    const availableHeight = window.innerHeight * 0.8;

    const scaleX = (availableWidth / baseWidth);
    const scaleY = (availableHeight / baseHeight);

    // mantém proporção 16:9
    const scale = Math.min(scaleX, scaleY);

    const viewport = document.getElementsByClassName("page-container")[0];
    if(viewport === undefined) return;
    
    viewport.style.position = 'absolute';
    viewport.style.top = '50%';
    viewport.style.left = '50%';
    viewport.style.margin = '0'; // Remove margens manuais anteriores
    
    // Translate centraliza dinamicamente (-50% do tamanho do elemento)
    // Scale aplica a proporção calculada
    viewport.style.transform = `translate(-50%, -50%) scale(${scale})`;
    viewport.style.transformOrigin = 'center center';
}

function App() {
  useEffect(() => {
    initPage();
    window.addEventListener('resize', initPage); 
    return () => window.removeEventListener('resize', initPage);
  }, [])
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/1" replace />} />
          {/* <Route path="/1" element={<Page1Simple />} />
          <Route path="/2" element={<Page2Simple />} />
          <Route path="/3" element={<Page3Simple />} />
          <Route path="/4" element={<Page4Simple />} />
          <Route path="/5" element={<Page5Simple />} /> */}
          {/* Rotas originais para comparação */}
          <Route path="1" element={<Page1 />} />
          <Route path="2" element={<Page2 />} />
          <Route path="3" element={<Page3 />} />
          <Route path="4" element={<Page4 />} />
          <Route path="5" element={<Page5 />} />
          <Route path="constelacao" element={<Constelacao />} />
          <Route path="radio" element={<Radio />} />
          <Route path="console" element={<Console />} />
          {/* Rotas de debug */}
          <Route path="/debug/1" element={<DebugRoute pageNumber={1} />} />
          <Route path="/debug/2" element={<DebugRoute pageNumber={2} />} />
          <Route path="/debug/3" element={<DebugRoute pageNumber={3} />} />
          <Route path="/debug/4" element={<DebugRoute pageNumber={4} />} />
          <Route path="/debug/5" element={<DebugRoute pageNumber={5} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
